import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class ConjointApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { id, responseActor, conjointConfig } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        const values = Object.values(value);

        const data = conjointConfig.tasks.map((task) => ({
            id: task.id,
            cards: task.cards.map((card) => ({
                answer: card.id,
                int: task.order,
                bool: values.includes(card.id) ? true : null,
            })),
            ...(value[task.id] === CANTRATE_ID && { cantRate: true }),
        }));

        return {
            question: id,
            data,
            comment,
        };
    }

    public validate({ params: { required }, conjointConfig, responseActor }: QuestionContext): boolean {
        const { value } = responseActor.getSnapshot().context;

        if (!required) return true;

        return Boolean(value) && Object.keys(value).length === conjointConfig.tasks.length;
    }
}
